import { useEffect, useState } from "react";
import ReactECharts from 'echarts-for-react';
import './comparison-pie.scss';
import { useParams } from "react-router-dom";

function ComparisonPie({
    competitors,
    clips
}: {
    competitors: any[],
    clips: any[]
}) {
    const [legend, setLegend] = useState<any[]>();
    const params: any = useParams();
    const [clipCount, setClipCount] = useState<number[]>();
    const colors = ['#A51D44', '#268792', '#2A9342', '#d48265', '#c23531', '#2F4554'];

    useEffect(() => {
        setLegend(competitors.map(item => item.Name));
    }, [params.clips, params.competitors, competitors])

    useEffect(() => {
        let counter: number[] = [];
        if (clips && clips.length > 0) {
            competitors.forEach((item, index) => {
                //_clipCount.push(clips.filter(clip => clip[item].BindId === item.BindId).length);
                counter.push(clips.filter(clip => clip.BinId === item.BinId).length);
            })
            setClipCount(counter);
        }
    }, [params.clips, clips])

    return (
        <div className="comparison-pie">
            <div className="top">
                <p>Clip Comparison</p>
            </div>
            <div className="body">
                <ReactECharts
                    style={{height: '420px'}}
                    option={{
                        tooltip: {
                        },
                        legend: {
                            orient: 'horizontal',
                            x: "center",
                            data: legend,
                        },
                        series: [
                            {
                                name: 'Competitor Comparison',
                                type: 'pie',
                                radius: ['50%', '70%'],
                                avoidLabelOverlap: true,
                                startAngle: 90,
                                label: {
                                    show: false,
                                    position: 'center'
                                },
                                emphasis: {
                                    label: {
                                        show: true,
                                        fontSize: '30',
                                        fontWeight: 'bold'
                                    }
                                },
                                labelLine: {
                                    show: false
                                },
                                data: competitors.map((item: any, index: number) => {
                                    return {
                                        name: item.Name,
                                        itemStyle: {
                                            color: colors[index]
                                        },
                                        value: clipCount ? clipCount[index] : 0
                                    }
                                })
                            }
                        ]
                    }}
                />
            </div>
        </div>
    )
}

export default ComparisonPie;